/* ==========================================================================
   Advisor popup — "Contact an advisor"
   - Abre/cierra el panel lateral
   - Envía el form de Zoho a un iframe oculto (evita recargar la página;
     Zoho no soporta fetch/CORS en este endpoint, por eso se usa target=iframe)
   - Muestra un mensaje de éxito dentro del propio popup, SOLO cuando el
     usuario ha pulsado realmente "Submit" en este popup abierto.
   ========================================================================== */
(function () {
  var overlay = document.querySelector('[data-pt-advisor-overlay]');
  if (!overlay) return;

  // Evita doble inicialización si el script se carga o ejecuta más de una
  // vez sobre el mismo overlay (p. ej. por un segundo script_tag, un app
  // embed duplicado, o una navegación bfcache).
  if (overlay.dataset.ptAdvisorInit === 'true') return;
  overlay.dataset.ptAdvisorInit = 'true';

  var closeBtn = overlay.querySelector('[data-pt-advisor-close]');
  var form = overlay.querySelector('[data-pt-advisor-form]');
  var successEl = overlay.querySelector('[data-pt-advisor-success]');
  var conceptInput = overlay.querySelector('[data-pt-advisor-concept]');
  var submitBtn = overlay.querySelector('[data-pt-advisor-submit]');
  var submitLabel = overlay.querySelector('[data-pt-advisor-submit-label]');
  var iframeTarget = overlay.querySelector('[data-pt-advisor-target]');

  var lastFocused = null;

  // En vez de un simple booleano, guardamos un identificador único por
  // cada submit real. El listener de 'load' solo actúa si hay un id
  // pendiente vigente — así, cualquier 'load' que no venga inmediatamente
  // después de un click real en "Submit" (carga inicial del iframe en
  // about:blank, recargas ajenas, eventos duplicados, bfcache, etc.)
  // queda descartado sin ambigüedad.
  var pendingSubmitId = null;

  function resetToIdle() {
    pendingSubmitId = null;
    successEl.hidden = true;
    form.hidden = false;
    submitBtn.removeAttribute('disabled');
    if (submitLabel) submitLabel.textContent = 'Submit';
  }
  resetToIdle();

  function openPopup(triggerEl) {
    lastFocused = triggerEl || document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var firstField = form.querySelector('input, textarea');
    if (firstField) {
      window.requestAnimationFrame(function () {
        firstField.focus();
      });
    }
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    window.setTimeout(function () {
      if (!overlay.classList.contains('is-open')) {
        form.reset();
        if (conceptInput) {
          conceptInput.value = conceptInput.getAttribute('value') || conceptInput.defaultValue;
        }
        resetToIdle();
      }
    }, 400);
  }

  document.querySelectorAll('[data-pt-advisor-btn], [data-pt-advisor-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openPopup(btn);
    });
  });

  closeBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closePopup();
    }
  });

  // Solo aquí nace un pendingSubmitId — es la única vía posible de que
  // el listener de 'load' llegue a mostrar el mensaje de éxito.
  form.addEventListener('submit', function () {
    pendingSubmitId = Date.now() + '-' + Math.random();
    submitBtn.setAttribute('disabled', 'disabled');
    if (submitLabel) submitLabel.textContent = 'Sending…';
  });

  iframeTarget.addEventListener('load', function () {
    if (!pendingSubmitId) return; // no hubo submit pendiente: se ignora
    if (!overlay.classList.contains('is-open')) {
      pendingSubmitId = null;
      return;
    }
    pendingSubmitId = null;
    form.hidden = true;
    successEl.hidden = false;
  });
})();